import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import taLogo from "../technologyadvice_logo.jpg";
import vytalLogo from "../vytal_icon.png";
import harvardLogo from "../harvard.png";
import broadLogo from "../broad.jpg";
import castelionLogo from "../castelionLogo.jpg";

const companyLogos = {
  Castelion: castelionLogo,
  TechnologyAdvice: taLogo,
  Vytal: vytalLogo,
  "Harvard Medical School": harvardLogo,
  "Broad Institute of MIT and Harvard": broadLogo,
};

const Resume = ({ data }) => {
  if (data) {
    var education = data.education.map(function (education) {
      return (
        <div key={education.school}>
          <h3 className="text-white">{education.school}</h3>
          <p className="info text-gray-200">
            {education.degree} {education.degree !== "" && <span>&bull;</span>}
            <em className="date text-gray-200">{education.graduated}</em>
          </p>
          <span className="text-gray-200 info ">Cum. GPA: {education.gpa}</span>
          <p className="info text-gray-200">{education.description}</p>
        </div>
      );
    });
    var work = data.work.map((work, i) => {
      // Convert existing description into technologies array if needed
      const technologies = work.technologies || [];

      return (
        <VerticalTimelineElement
          key={work.company}
          className="vertical-timeline-element--work"
          iconStyle={{
            background: "#fff",
            color: "#000",
            textAlign: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          icon={
            <img
              src={companyLogos[work.company]}
              alt="Company Logo"
              className="rounded-full w-full h-full object-contain p-2"
            />
          }
        >
          <h4 className="text-3xl font-bold text-gray-600 mb-2">
            {work.title} @ {work.company}
          </h4>
          <h4 className="text-lg text-gray-600 mb-2">{work.years}</h4>

          <p className="text-gray-700 mb-4">{work.description}</p>

          <div className="flex flex-wrap gap-2 mt-4">
            {technologies.map((tech, index) => (
              <span
                key={index}
                className="px-2 py-1 text-sm text-gray-700 bg-gray-200 rounded-full"
              >
                {tech}
              </span>
            ))}
          </div>
        </VerticalTimelineElement>
      );
    });
  }

  return (
    <section id="resume">
      <div className="flex flex-col items-center justify-start pl-6 education">
        <div className="mb-6">
          <h1>
            <span className="text-white">Education</span>
          </h1>
        </div>

        <div className="row item">
          <div className="twelve columns">{education}</div>
        </div>
      </div>

      <div className="mx-auto pt-10 px-4 ">
        <div className="mb-12 mt-10">
          <h1 className="text-3xl font-bold text-center text-white">
            Work Experience
          </h1>
        </div>

        <div className="mx-auto">
          <VerticalTimeline className="w-full">{work}</VerticalTimeline>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center pt-20 skill ">
        <div className="three columns header-col mb-10">
          <h1>
            <span className="text-white">Skills</span>
          </h1>
        </div>
        <div className="skills w-3/4 pb-32">
          <div className="languages flex flex-col gap-10">
            <h3>
              <span className="text-white">Languages</span>
            </h3>
            <div className="icons">
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/python/python-icon.svg"
                  alt="Python"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://upload.vectorlogo.zone/logos/javascript/images/239ec8a4-163e-4792-83b6-3f6d96911757.svg"
                  alt="JavaScript"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/typescriptlang/typescriptlang-icon.svg"
                  alt="TypeScript"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/java/java-icon.svg"
                  alt="java"
                  width="40"
                  height="40"
                />
              </div>
              <div style={{ marginTop: 8 + "px" }}>
                <img
                  src="https://www.vectorlogo.zone/logos/golang/golang-official.svg"
                  alt="Golang"
                  width="70"
                  height="70"
                />
              </div>
            </div>
          </div>
          <div className="languages flex flex-col gap-10">
            <h3>
              <span className="text-white">Web/Mobile Dev</span>
            </h3>
            <div className="icons">
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                  alt="React"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/js_redux/js_redux-icon.svg"
                  alt="Redux"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://raw.githubusercontent.com/gilbarbara/logos/master/logos/material-ui.svg"
                  alt="Material-UI"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg"
                  alt="Kotlin"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/expoio/expoio-icon.svg"
                  alt="Expo"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/tailwindcss/tailwindcss-icon.svg"
                  alt="TailwindCSS"
                  width="40"
                  height="40"
                />
              </div>
            </div>
          </div>
          <div className="languages flex flex-col gap-10">
            <h3>
              <span className="text-white">Back-End</span>
            </h3>
            <div className="icons">
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg"
                  alt="Firebase"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/heroku/heroku-icon.svg"
                  alt="Heroku"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/google_cloud/google_cloud-icon.svg"
                  alt="Google Cloud"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/nodejs/nodejs-icon.svg"
                  alt="NodeJS"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg"
                  alt="Postman"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg"
                  alt="MongoDB"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/palletsprojects_flask/palletsprojects_flask-icon.svg"
                  alt="Flask"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/nextjs/nextjs-icon.svg"
                  alt="NextJS"
                  width="40"
                  height="40"
                />
              </div>
              <div>
                <img
                  src="https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg"
                  alt="PostgreSQL"
                  width="40"
                  height="40"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
